<template>
  <v-container>
    <v-row>
      <!-- <v-col>
        <v-card class="text-center px-5 pb-5">
          <v-card-subtitle>Über das</v-card-subtitle>
          <v-card-text class="text-center">
            <div
              class="text-h5 font-weight-medium text--primary"
              style="opacity: 0.8"
            >
              Übungstool
            </div>
          </v-card-text>
          <v-card-text class="text-justify pb-5">
            Das Übungstool stellt alle Materialien für das aktuelle Semester zur
            Verfügung und erlaubt der Übungsleitung mithilfe eines
            LaTex-Templates schnell und einfach neue Übungen zu erstellen, die
            Studenten für Ihre Vorbereitungen nutzen können.
          </v-card-text>
          <v-card-actions>
            <v-btn
              block
              depressed
              class="white--text"
              color="tertiary"
              @click="$router.push('/exercises')"
              >Zum Tool</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col> -->
      <v-col>
        <v-card class="text-center px-5 pb-5">
          <v-card-subtitle>Über das</v-card-subtitle>
          <v-card-text>
            <div
              class="text-h5 font-weight-medium text--primary"
              style="opacity: 0.8"
            >
              Tutor-Management-Tool
            </div>
          </v-card-text>
          <v-card-text class="text-justify pb-5">
            Das Tutor-Management-Tool dient dem Management des Übungsbetriebs.
            Hier können Studenten alle anstehenden Tutorien einsehen und ihr
            Tutorium abonnieren, um alle wichtigen Informationen, wie die
            Termine, den Tutor und Standort, sowie Änderungen oder Absagen, zu
            erhalten. Die Tutoren können ihre eigenen Tutorien verwalten, an
            Matchings zur Verteilung von Tutoren zu Tutorien teilnehmen und
            Ergeignisse, wie das Tauschen, Ersetzen oder Absagen von einzelnen
            Tutorstunden.
          </v-card-text>
          <v-card-actions>
            <v-btn
              block
              depressed
              class="white--text"
              color="tertiary"
              @click="$router.push('/tutorials')"
              >Zum Tool</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<!-- TODO: give feedback, when Login credentials are wrong -->

<script>
export default {
  name: "AboutView",
  data: () => ({}),
  methods: {},
};
</script>
